import { RentInvoicingOrderSettings } from './rent-invoicing-order-settings';

export class RentInvoicingOrderCreateSingleModel {
  appendixes: any[] = [];
  settings: RentInvoicingOrderSettings = new RentInvoicingOrderSettings();
}
